<template>
    <div class="a">
        <top></top>
        <navs></navs>
        <div class="content">
            <div class="cont_a">
                <div class="cont_b">
                    <a href="http://live.jnccljh.com/ms/post579/msg-file29937e08479845e0c202419762c8630d.html">
                        <div class="cont_top">
                            <img :src="zimgae" alt="" width="100%" height="277px">
</div>
<div class="cont_bottom">
    <div class="center">
        直播入口
    </div>
</div>
                    </a>

                </div>
                <div class="cont_b" @click="time">
                    <div class="cont_top">
                        <img :src="jimage" alt="" width="100%" height="277px">
                    </div>
                    <div class="cont_bottom" >
                        <div class="center">
                            聚会时间表
                        </div>
                    </div>
                </div>
                <div class="cont_b" @click="download">
                    <div class="cont_top">
                        <img :src="image" alt="" width="100%" height="277px">
                    </div>
                    <div class="cont_bottom">
                        <div class="center">
                            APP下载
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import {app,qlcb,jtime,ztime} from "../api/index"
export default {
    components: {
        top,
        bottom,
        navs
    },
    data(){
        return{
            image:"",
            zimage:"",
            jimage:""
        }
    },
    created(){
        app().then(res=>{
            this.image = res.data.data.image1
            console.log(this.image)

        })
        // qlcb().then(res=>{
        //     console.log(res)
        //     this.zimgae = res.data.data.liveThumb
        //     this.jimage = res.data.data.worshipThumb
        // })
        jtime().then(res=>{
          console.log(res)
          this.jimage = res.data.data.image1
        })
        ztime().then(res=>{
          this.zimgae = res.data.data.image1
        })
    },
    methods:{
        time(){
            this.$router.push({path:"/time"})
        },
        download(){
            this.$router.push({path:"/Download"})
        }
    }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}
.content{
    width: 100%;
    height: 480px;
    background-image: url(../image/back.png);
    padding-top: 40px;
    padding-bottom: 40px;
}
a{
    text-decoration:none;
}
.cont_a{
    width: 70%;
    margin: 0 auto;
    height: 480px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.cont_b{
    width: 31%;
    height: 372px;
    background: #FFFFFF;
    box-shadow: 4px 4 6px 0px rgba(75,98,168,0.3);
}
.cont_top{
    width: 100%;
    height: 277px;
}
.cont_bottom{
    height: 95px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.center{
    width: 1.2625rem;
height: 32px;
box-shadow: 4px 4 6px 0px rgba(75,98,168,0.3);
border: 1px solid #1463FF;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: .1625rem;
color: #1463FF;
text-shadow: 4px 4px 6px rgba(75,98,168,0.3);
font-style: normal;
display: flex;
align-items: center;
justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/wl.vue